import { render, staticRenderFns } from "./admin-disabilities.vue?vue&type=template&id=3f3fe9b4&scoped=true"
import script from "./admin-disabilities.vue?vue&type=script&lang=js"
export * from "./admin-disabilities.vue?vue&type=script&lang=js"
import style0 from "./admin-disabilities.vue?vue&type=style&index=0&id=3f3fe9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3fe9b4",
  null
  
)

export default component.exports